import { IBusinessConfigs } from '../_Common/Const/BusinessConfigs';
import { initConst } from '../../../Utils/utils';
import { TEDSYSReportNewVISIBILITYEnum } from '../../../globalQueryTypes';

const SYSBusinessConfig = initConst<IBusinessConfigs>(() => ({
  SYSValuta: {
    // addComponent: ValutaAdd,
    defaultColumns: [
      { attributeDef: 'VALUTAKOD', caption: 'Valutakod', header: true },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'FASTKURS', caption: 'Fastkurs' },
    ],
  },
  SYSUser: {
    attributes: { Fullname: { tableDefaultWidth: 160 } },
    defaultColumns: [
      { attributeDef: 'SIGNATURE', caption: 'Signatur' },
      { attributeDef: 'Fullname', caption: 'Namn' },
      { attributeDef: 'SIGNATURE', caption: 'Signatur' },
      { attributeDef: 'Fullname', caption: 'Namn' },
      { attributeDef: 'Arbetsstalle.BENAMNING', caption: '' },
      { attributeDef: 'PHONE', caption: 'Telefon' },
      { attributeDef: 'LOCATION', caption: 'Lokal' },
      { attributeDef: 'EMAIL', caption: 'E-postadress' },
    ],
  },
  SYSRoll: {
    defaultColumns: [
      { attributeDef: 'SIGNATURE', caption: 'Signatur' },
      { attributeDef: 'Name', caption: 'Namn' },
      { attributeDef: 'IDKOD', caption: 'GBS-roll' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
    ],
  },
  SYSArbetsstalle: {
    defaultColumns: [{ attributeDef: 'BENAMNING', caption: 'Benämning' }],
  },
  SYSBokfar: {
    defaultColumns: [
      { attributeDef: 'BOKF_AR', caption: 'Bokf.år' },
      { attributeDef: 'FRAN_DATUM', caption: 'Fr o m datum' },
      { attributeDef: 'TILL_DATUM', caption: 'T o m datum' },
      { attributeDef: 'LAST', caption: 'Låst' },
    ],
  },
  SYSKonteringskod: {
    defaultColumns: [
      { attributeDef: 'KOD', caption: 'Kod' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'Standard', caption: 'Standard' },
    ],
  },
  SYSMoms: {
    defaultColumns: [
      { attributeDef: 'MOMSKOD', caption: '', header: true },
      { attributeDef: 'BENAMNING', caption: '', header: true },
    ],
  },
  SYSBank: {
    defaultColumns: [
      { attributeDef: 'CLEARINGNR', caption: 'Clearingnr' },
      // { attributeDef: 'NAMN', caption: 'Namn' },
      { attributeDef: 'ADRESS', caption: 'Adress' },
      { attributeDef: 'POSTNUMMER', caption: 'Postnr' },
      { attributeDef: 'POSTADRESS', caption: 'Postadress' },
      { attributeDef: 'SWIFT_ADRESS', caption: 'SWIFT-adress' },
      { attributeDef: 'SORTCODE', caption: 'Sortcode' },
    ],
  },
  SYSSIEMottagningsvag: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'IMPORTKATALOG', caption: 'Importkatalog' },
      { attributeDef: 'Bokfgrupp.BENAMNING', caption: 'Bokföringsgrupp' },
      { attributeDef: 'AKTIV', caption: 'Aktiv' },
    ],
  },
  SYSOrdermottagningsvag: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'IMPORTTYP', caption: 'Importtyp' },
      { attributeDef: 'AKTIV', caption: 'Aktiv' },
    ],
  },
  SYSUtbetalningsvag: {
    defaultColumns: [{ attributeDef: 'TypBen', caption: 'Typ' }],
  },
  SYSUtbetalningssatt: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning', header: true },
    ],
  },
  SYSLeveransvillkor: {
    defaultColumns: [
      { attributeDef: 'LEVVILLKORKOD', caption: '' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
    ],
  },
  SYSFakturakod: {
    defaultColumns: [
      { attributeDef: 'KOD', caption: 'Referens' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'Standard', caption: 'Standard' },
    ],
  },
  SYSFakturaradskod: {
    defaultColumns: [
      { attributeDef: 'KOD', caption: 'Referens' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'Standard', caption: 'Standard' },
    ],
  },
  SYSFakturaformedlare: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      {
        attributeDef: 'FAKTURERINGSSATT',
        caption: 'Gäller för faktureringssätt',
      },
      { attributeDef: 'KalkLeveranskatalog', caption: 'Leveranskatalog' },
      { attributeDef: 'KalkKvittenskatalog', caption: 'Kvittenskatalog' },
    ],
  },
  SYSBetalningssatt: {
    defaultColumns: [
      { attributeDef: 'BETSATTKOD', caption: 'Betalningssätt' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'TYP', caption: 'Typ' },
      { attributeDef: 'Bank.CLEARINGNR', caption: 'Bank' },
    ],
  },
  SYSBetalningsvillkor: {
    defaultColumns: [
      { attributeDef: 'BETALNINGSVILLKORKOD', caption: '' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
    ],
  },
  SYSKravrutin: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: '' },
      {
        attributeDef: 'FAKTURERA_DROJSMALSRANTA',
        caption: 'Fakturera dröjsmålsränta',
      },
      {
        attributeDef: 'FAKTURERA_PAMINNELSEAVGIFT',
        caption: 'Fakturera påminnelseavgift',
      },
      { attributeDef: 'PAMINNELSEAVGIFT', caption: 'Påminnelseavgift' },
    ],
  },
  SYSRanteTabell: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'TYP', caption: 'Typ' },
      { attributeDef: 'ANVANDSFOR', caption: 'Används för' },
      { attributeDef: 'Basrantetabell', caption: '(Basräntetabell)' },
    ],
  },
  SYSAutogiroMall: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'BETALNINGSDAG', caption: 'Bet.dag' },
      { attributeDef: 'Dragningar', caption: 'Dragningstillfällen' },
    ],
  },
  SYSFakturalayout: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'UTSKRIFTSTYP', caption: 'Utskriftstyp' },
    ],
  },
  SYSLand: {
    defaultColumns: [
      { attributeDef: 'LANDKOD', caption: 'Landkod' },
      { attributeDef: 'BENAMNING', caption: 'Namn' },
    ],
  },
  SYSSprak: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Namn' },
      { attributeDef: 'AndraSprak', caption: 'Andraspråk' },
      { attributeDef: 'SYSTEMSPRAK', caption: 'Systemspråk' },
    ],
  },
  SYSTitel: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Titel' },
      { attributeDef: 'KR_SORT', caption: 'Prioritet i KR' },
      { attributeDef: 'LR_SORT', caption: 'Prioritet i LR' },
    ],
  },
  SYSBokngrupp: {
    defaultColumns: [{ attributeDef: 'BENAMNING', caption: 'Benämning' }],
  },
  SYSStandardtext: {
    defaultColumns: [{ attributeDef: 'TEXT', caption: 'Text' }],
  },
  SYSDiariegrupp: {
    defaultColumns: [
      { attributeDef: 'KOD', caption: 'Kod' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
    ],
  },
  SYSPOSTNR: {
    defaultColumns: [
      { attributeDef: 'ADRESS', caption: 'Adress' },
      { attributeDef: 'POSTNR', caption: 'Postnr' },
      { attributeDef: 'ORT', caption: 'Ort' },
      { attributeDef: 'Lan', caption: 'Län' },
      { attributeDef: 'Kommun', caption: 'Kommun' },
      { attributeDef: 'benKod', caption: 'Församling' },
      // { attributeDef: 'LKF', caption: 'LKF-kod' },
      { attributeDef: 'benStatus', caption: 'Status' },
    ],
  },
  SYSKOBArtikel: {
    defaultColumns: [
      { attributeDef: 'ARTIKELNR', caption: 'Artikelnr' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'KOBArtikelPris', caption: 'Pris' },
      { attributeDef: 'FORRATTNINGSTYP', caption: 'Förrättningstyp' },
      { attributeDef: 'TOM_DATUM', caption: 'Giltig t.o.m.' },
    ],
  },
  SYSNummerserie: {
    defaultColumns: [{ attributeDef: 'BENAMNING', caption: 'Benämning' }],
  },
  SYSKurs: {
    defaultColumns: [
      {
        attributeDef: 'FROM_DATUM',
        caption: 'Fr o m datum',
        header: true,
      },
      { attributeDef: 'TOM_DATUM', caption: 'T o m datum' },
      { attributeDef: 'SALJKURS', caption: 'Säljkurs' },
    ],
  },
  SYSGrupp: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning', header: true },
    ],
  },
  SYSJobb: {
    defaultColumns: [
      { attributeDef: 'RUBRIK', caption: 'Namn', header: true },
      { attributeDef: 'STATUS', caption: 'Status' },
      { attributeDef: 'STATUS_TEXT', caption: 'Info' },
      { attributeDef: 'START_TID', caption: 'Starttid' },
      { attributeDef: 'SLUT_TID', caption: 'Sluttid' },
      { attributeDef: 'PROGRESS', caption: '% klart' },
      { attributeDef: 'TidKlar', caption: 'Klart (uppskattad tid)' },
    ],
  },
  SYSJobbLogg: {
    defaultColumns: [
      { attributeDef: 'STATUS', caption: 'Status', header: true },
      { attributeDef: 'TID', caption: 'Tid' },
    ],
  },
  SYSStatistikinstallningar: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning', header: true },
    ],
  },
  SYSReportNew: {
    defaultColumns: [
      { attributeDef: 'REPORTNAME', header: true },
      { attributeDef: 'DESCRIPTION' },
      { attributeDef: 'SubsystemLabel' },
      { attributeDef: 'CollectionLabel' },
      { attributeDef: 'SynligFor' },
      { attributeDef: '_typ' },
    ],
    colors: {
      styles: [
        {
          caption: 'Blankett från kyrkokansliet',
          color: 'lightBlue',
          condition: (data: any) => data.IsArbgivarRapport,
          dataDependencies: ['IsArbgivarRapport'],
        },
        {
          caption: 'Gemensam rapport',
          color: 'lightGreen',
          condition: (data: any) =>
            data.VISIBILITY ===
              TEDSYSReportNewVISIBILITYEnum.GEMENSAM_RAPPORT &&
            !data.IsArbgivarRapport,
          dataDependencies: ['VISIBILITY', 'IsArbgivarRapport'],
        },
        {
          caption: 'Privat rapport',
          color: 'blueGray',
          colorOpacity: 'faded',
          condition: (data: any) =>
            data.VISIBILITY === TEDSYSReportNewVISIBILITYEnum.MIN_RAPPORT &&
            !data.IsArbgivarRapport,
          dataDependencies: ['VISIBILITY', 'IsArbgivarRapport'],
        },
      ],
    },
  },
}));

export default SYSBusinessConfig;
